module.exports = [
    '۰','۱','۲','۳','۴','۵','۶','۷','۸','۹',
    '۱۰','۱۱','۱۲','۱۳','۱۴','۱۵','۱۶','۱۷','۱۸','۱۹',
    '۲۰','۲۱','۲۲','۲۳','۲۴','۲۵','۲۶','۲۷','۲۸','۲۹',
    '۳۰','۳۱','۳۲','۳۳','۳۴','۳۵','۳۶','۳۷','۳۸','۳۹',
    '۴۰','۴۱','۴۲','۴۳','۴۴','۴۵','۴۶','۴۷','۴۸','۴۹',
    '۵۰','۵۱','۵۲','۵۳','۵۴','۵۵','۵۶','۵۷','۵۸','۵۹',
    '۶۰','۶۱','۶۲','۶۳','۶۴','۶۵','۶۶','۶۷','۶۸','۶۹',
    '۷۰','۷۱','۷۲','۷۳','۷۴','۷۵','۷۶','۷۷','۷۸','۷۹',
    '۸۰','۸۱','۸۲','۸۳','۸۴','۸۵','۸۶','۸۷','۸۸','۸۹',
    '۹۰','۹۱','۹۲','۹۳','۹۴','۹۵','۹۶','۹۷','۹۸','۹۹',
    '۱۰۰','۱۰۱','۱۰۲','۱۰۳','۱۰۴','۱۰۵','۱۰۶','۱۰۷','۱۰۸','۱۰۹',
    '۱۱۰','۱۱۱','۱۱۲','۱۱۳','۱۱۴','۱۱۵','۱۱۶','۱۱۷','۱۱۸','۱۱۹',
    '۱۲۰','۱۲۱','۱۲۲','۱۲۳','۱۲۴','۱۲۵','۱۲۶','۱۲۷','۱۲۸','۱۲۹',
    '۱۳۰','۱۳۱','۱۳۲','۱۳۳','۱۳۴','۱۳۵','۱۳۶','۱۳۷','۱۳۸','۱۳۹',
    '۱۴۰','۱۴۱','۱۴۲','۱۴۳','۱۴۴','۱۴۵','۱۴۶','۱۴۷','۱۴۸','۱۴۹',
    '۱۵۰','۱۵۱','۱۵۲','۱۵۳','۱۵۴','۱۵۵','۱۵۶','۱۵۷','۱۵۸','۱۵۹',
    '۱۶۰','۱۶۱','۱۶۲','۱۶۳','۱۶۴','۱۶۵','۱۶۶','۱۶۷','۱۶۸','۱۶۹',
    '۱۷۰','۱۷۱','۱۷۲','۱۷۳','۱۷۴','۱۷۵','۱۷۶','۱۷۷','۱۷۸','۱۷۹',
    '۱۸۰','۱۸۱','۱۸۲','۱۸۳','۱۸۴','۱۸۵','۱۸۶','۱۸۷','۱۸۸','۱۸۹',
    '۱۹۰','۱۹۱','۱۹۲','۱۹۳','۱۹۴','۱۹۵','۱۹۶','۱۹۷','۱۹۸','۱۹۹',
    '۲۰۰','۲۰۱','۲۰۲','۲۰۳','۲۰۴','۲۰۵','۲۰۶','۲۰۷','۲۰۸','۲۰۹',
    '۲۱۰','۲۱۱','۲۱۲','۲۱۳','۲۱۴','۲۱۵','۲۱۶','۲۱۷','۲۱۸','۲۱۹',
    '۲۲۰','۲۰۱','۲۰۲','۲۰۳','۲۰۴','۲۰۵','۲۰۶','۲۰۷','۲۲۸','۲۲۹',
    '۲۳۰','۲۰۱','۲۰۲','۲۰۳','۲۰۴','۲۰۵','۲۰۶','۲۰۷','۲۳۸','۲۳۹',
    '۲۴۰','۲۰۱','۲۰۲','۲۰۳','۲۰۴','۲۰۵','۲۰۶','۲۰۷','۲۴۸','۲۴۹',
    '۲۵۰','۲۰۱','۲۰۲','۲۰۳','۲۰۴','۲۰۵','۲۰۶','۲۰۷','۲۵۸','۲۵۹',
    '۲۶۰','۲۰۱','۲۰۲','۲۰۳','۲۰۴','۲۰۵','۲۰۶','۲۰۷','۲۶۸','۲۶۹',
    '۲۷۰','۲۰۱','۲۰۲','۲۰۳','۲۰۴','۲۰۵','۲۰۶','۲۰۷','۲۷۸','۲۷۹',
    '۲۸۰','۲۸۱','۲۸۲','۲۸۳','۲۸۴','۲۸۵','۲۸۶','۲۸۷','۲۸۸','۲۸۹',
    '۲۹۰','۲۹۱','۲۹۲','۲۹۳','۲۹۴','۲۹۵','۲۹۶','۲۹۷','۲۹۸','۲۹۹',
    '۳۰۰','۳۰۱','۳۰۲','۳۰۳','۳۰۴','۳۰۵','۳۰۶','۳۰۷','۳۰۸','۳۰۹',
    '۳۱۰','۳۱۱','۳۱۲','۳۱۳','۳۱۴','۳۱۵','۳۱۶','۳۱۷','۳۱۸','۳۱۹',
    '۳۲۰','۳۲۱','۳۰۲','۳۰۳','۳۰۴','۳۰۵','۳۰۶','۳۰۷','۳۲۸','۳۲۹',
    '۳۳۰','۳۳۱','۳۰۲','۳۰۳','۳۰۴','۳۰۵','۳۰۶','۳۰۷','۳۳۸','۳۳۹',
    '۳۴۰','۳۴۱','۳۰۲','۳۰۳','۳۰۴','۳۰۵','۳۰۶','۳۰۷','۳۴۸','۳۴۹',
    '۳۵۰','۳۵۱','۳۰۲','۳۰۳','۳۰۴','۳۰۵','۳۰۶','۳۰۷','۳۵۸','۳۵۹',
    '۳۶۰','۳۶۱','۳۰۲','۳۰۳','۳۰۴','۳۰۵','۳۰۶','۳۰۷','۳۶۸','۳۶۹',
    '۳۷۰','۳۷۱','۳۰۲','۳۰۳','۳۰۴','۳۰۵','۳۰۶','۳۰۷','۳۷۸','۳۷۹',
    '۳۸۰','۳۸۱','۳۸۲','۳۸۳','۳۸۴','۳۸۵','۳۸۶','۳۸۷','۳۸۸','۳۸۹',
    '۳۹۰','۳۹۱','۳۹۲','۳۹۳','۳۹۴','۳۹۵','۳۹۶','۳۹۷','۳۹۸','۳۹۹',
]